const initialState = {
  email: "",
  user: "",
  canEdit: false,
  canBook: false,
  isBookingAdmin: false,
  cidmGroups: [],
  irRole: "Viewer",
  irGroups: []
};

export default initialState;
